import axios, { AxiosRequestConfig } from "axios";
import { Config } from "../../data/Config";
import Cookies from "js-cookie";
import { useOrganization } from "../entities/useOrganization";
import { COOKIENAME_CURRENT_ORGANIZATION_ID } from "../../data/redux/organizationReducer";
import { localStore } from "../../data/io/localStore";
import { StorageKey_ui_settings_language } from "../../data/redux/uIReducer";
import { useResources } from "../../../translations/translations";

type onDownloadProgressType = {
    loaded: number;
    total: any;
    progress: any;
    bytes: any;
    estimated: any;
    rate: any;
    download?: boolean | undefined;
};

export const useFetch = () => {

    const jwt = useJwt();
    const langKey = useResources();

    const getConfig = (formPost?: boolean) => {
        let c: AxiosRequestConfig = {
            baseURL: Config.serverUrl,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                accept: 'application/json',
                "Content-Type": formPost === true ? "multipart/form-data" : "application/json",
                Authorization: "Bearer " + jwt.getJwt(),
                "app-organizationid": Cookies.get(COOKIENAME_CURRENT_ORGANIZATION_ID),
                "app-locale": langKey.current,
                "app-platform": "web",
                "app-language": langKey.current,
            },
            withCredentials: false, // default
        }
        return c;
    }
    const getUrlWithDomain = (url: string) => {
        if (url?.startsWith("https://")) {
            return url;
        } else {
            return Config.serverUrl + url;
        }
    }

    const get = async (url: string) => {
        const c = getConfig();
        const d = await axios.get(getUrlWithDomain(url), c);
        return d?.data;
    }

    const post = async (url: string, obj: any) => {
        const c = getConfig();
        const d = await axios.post(getUrlWithDomain(url), obj, c);
        return d?.data;
    }

    const postForm = async (url: string, obj: any) => {
        const c = getConfig(true);
        const d = await axios.post(getUrlWithDomain(url), obj, c);
        return d?.data;
    }

    const patch = async (url: string, obj: any) => {
        const c = getConfig();
        const d = await axios.patch(getUrlWithDomain(url), obj, c);
        return d?.data;
    }

    const del = async (url: string) => {
        const c = getConfig();
        const d = await axios.delete(getUrlWithDomain(url), c);
        return d?.data;
    }

    return {
        hasLoginToken: jwt.hasJwt(),
        get: async (url: string) => {
            return await get(url);
        },
        post: async (url: string, postObj: any) => {
            return await post(url, postObj);
        },
        patch: async (url: string, postObj?: any) => {
            return await patch(url, postObj);
        },
        delete: async (url: string) => {
            return await del(url);
        },
        postForm: async (url: string, postObj: FormData) => {
            return await postForm(url, postObj);
        },
    }

}



export const useJwt = () => {
    const key_jwt = "jwt";

    return {
        hasJwt: () => {
            const jwt = Cookies.get(key_jwt) ?? "";
            return (jwt).length > 50;
        },
        getJwt: () => {
            const jwt = Cookies.get(key_jwt) ?? "";
            return jwt;
        },
        setJwt: (e: string) => {
            Cookies.set(key_jwt, e, { sameSite: 'strict', secure: true, expires: 30 });
        },
        removeJwt: () => {
            Cookies.remove(key_jwt);
        },
    }
}